import type { CreationWithTask, TaskInfo } from '@/app/types';

export const resolveOfflineAvatarHistoryCreation = (
  selectedCreation: CreationWithTask,
  taskList: TaskInfo[],
): CreationWithTask => {
  const latestTask = taskList.find((task) => task.id === selectedCreation.task.id);
  const latestCreation = latestTask?.creations?.find((creation) => creation.id === selectedCreation.id);

  return latestTask && latestCreation ? { ...selectedCreation, ...latestCreation, task: latestTask } : selectedCreation;
};
